import { adminApi, getAdminToken, setAdminToken } from '../api'

function notifySessionSync() {
  window.dispatchEvent(new Event('admin-session-sync'))
}

/** 校验 localStorage 中的 JWT；无效则清除。不会静默用账号密码登录。 */
export async function validateSession(): Promise<boolean> {
  if (!getAdminToken()) return false
  try {
    await adminApi.get('/admin/auth/me')
    notifySessionSync()
    return true
  } catch {
    setAdminToken(null)
    notifySessionSync()
    return false
  }
}
